import Vue from "vue";
import VueI18n from "vue-i18n";
import Cookies from "js-cookie";

import elementEnLocal from 'element-ui/lib/locale/lang/en'
import elementZhLocal from 'element-ui/lib/locale/lang/zh-CN'
import elementKoLocal from 'element-ui/lib/locale/lang/ko'
import elementJaLocal from 'element-ui/lib/locale/lang/ja'

import enLocal from './en'
import zhLocal from './zh'
import koLocal from './ko'
import jaLocal from './ja'

Vue.use(VueI18n)

const i18n = new VueI18n({
    locale: Cookies.get('language') || 'zh',

    messages: {
        en: {
            ...enLocal,
            ...elementEnLocal
        },
        zh: {
            ...zhLocal,
            ...elementZhLocal
        },
        ko: {
            ...koLocal,
            ...elementKoLocal
        },
        ja: {
            ...jaLocal,
            ...elementJaLocal
        }
    }

});

export default i18n